import APIV5 from '~/models/api';
import FileUpload from '~/scripts/services/model/file-upload';

export default class FilePreviewMultipleModalController {
	/* @ngInject */
	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ITimeoutService} $timeout,
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		kid,
		$injector,
		$timeout,
		$uibModalInstance,
	) {
		this.kid = kid;
		this.$injector = $injector;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;

		/** @type {?string} */
		this.fileActiveId = null;

		/** @type {import('~/scripts/services/model/file-upload').default[]} */
		this.files = [];

		(async () => this.init())();
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	async init() {
		const infos = await APIV5.instance.fileInfoMultiple(
			{
				nodeid: this.kid,
				type:   'viewer',
			},
			{
				id: 'kform-tab-file.load-file',
			},
		);

		this.files = infos.files.map((/** @type {any} */ f) => {
			const file = new FileUpload(
				this.$injector,
				f,
				f.name.user,
			);
			file.loaded = file.file.size;
			return file;
		});
		this.$timeout(() => {
			this.fileActiveId = this.files.length > 0 ? this.files[0].file.id : null;
		});
	}
}
